import './src/styles/global.css'
import scrollDelay from './shouldUpdateScroll'

export { wrapRootElement } from './wrapRootElement'
export const shouldUpdateScroll = scrollDelay
